import React, { useState } from "react";
import { withPrefix, navigate } from "gatsby";

import Button from "../button/button";
import ShareModal from "../../molecules/share-modal/shareModal";
import { normalizeTwoWords, formatImageAlt, findRel } from "../../../shared/utils/stringUtilities";

import "./cardPodcastRotator.scss";

interface CardPodcastRotatorInter {
  podcast: any;
  gtmClass: string;
}

const CardPodcastRotator = (props: CardPodcastRotatorInter) => {
  const { podcast, gtmClass } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const seeAll = () => {
    navigate(`/ver-todo/?title=Episodios recientes` +
    `&searchType=filter` +
    `&contentType=Libros` + 
    `&searchParam=word,contentType` +
    `&paramValues=/-podcast/-/-/-DATE`,
     {
      state: {
      },
    });
  };


  if (podcast === "Ver todo") return (
    <div className="card__seeAll">
      <Button
        type='button'
        classname='primary'
        text='Ver todos los Podcast'
        isDisabled={false}
        onClickAction={seeAll}
      /></div>);

  return (
    <div className="a-card-podcast-rotator">
      <a
        href={withPrefix(podcast.slug)}
        className="a-card-podcast-rotator__img"
        rel={findRel(podcast.slug)}
      >
        <img
          src={podcast.image.file.url}
          alt={podcast.image.title ? formatImageAlt(podcast.image.title) : `Portada ${podcast.titulo}`}
          className={`gtm${normalizeTwoWords(
            gtmClass
          )}Lectura${normalizeTwoWords(podcast.titulo)}`}
        />
        <div className="a-card-podcast-rotator__img-icon">
          <p className="icon-microphone a-card-podcast-rotator__img-icon__shared"></p>
        </div>
      </a>

      <div className="a-card-podcast-rotator__description">
        <a
          href={withPrefix(podcast.slug)}
          className="a-card-podcast-rotator__description-name"
          rel={findRel(podcast.slug)}
        >
          {podcast.titulo}
        </a>
        <span className="a-card-podcast-rotator__description-author">
          {podcast.autor}
        </span>
      </div>

      <hr className="a-card-podcast-rotator__separator" />

      <div className="a-card-podcast-rotator__icons">
        <div
          className="a-card-podcast-rotator__icons-share"
          onClick={toggleModal}
        >
          <p
            className={`icon-share a-card-podcast-rotator__icons-share__icon gtm${normalizeTwoWords(
              gtmClass
            )}Lectura${normalizeTwoWords(podcast.titulo)}Compartir`}
          ></p>
        </div>
      </div>

      <ShareModal
        open={isModalVisible}
        onClose={toggleModal}
        href={withPrefix(podcast.slug)}
      />
    </div>
  );
};

export default CardPodcastRotator;
